import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { Box, CircularProgress } from '@mui/material';
import { UserAuth } from '../context/AuthContext';
import { db } from '../firebase.config';

const ProtectedRoute = ({ children }) => {
  const { user, logOut, initializing } = UserAuth();
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { eventID } = useParams();

  useEffect(() => {
    if (initializing) return; 
    console.log('coo11')
    const checkAccess = async () => {
      if (!user) {
        console.log('deconnexion auto')
        navigate('/login');
        return;
      }

      try {
        const organiserRef = doc(db, 'organisateurs', user.uid);
        const organiserSnap = await getDoc(organiserRef);

        if (!organiserSnap.exists()) {
          console.log('je ne suis pas orgnisateur')
          setIsAuthorized(true);
          navigate('/register/organisation', { replace: true });
          return
        }

        const organiserData = organiserSnap.data();
        const idOrg = organiserData?.idOrg;

        if (!idOrg) {
          setIsAuthorized(true);
          navigate('/register/organisation', { replace: true })
          return
        }

        const orgRef = doc(db, 'organisations', idOrg);
        const orgSnap = await getDoc(orgRef);

        if (!orgSnap.exists() || !orgSnap.data()?.certified) {
          setIsAuthorized(true);
          navigate('/register/organisation', { replace: true });
          return
        }

        if (eventID) {
          const eventRef = doc(db, 'evenement', eventID);
          const eventSnap = await getDoc(eventRef);

          if (!eventSnap.exists() || eventSnap.data()?.orgId !== idOrg) {
            return navigate('/bo'); // Accès refusé à l'événement
          }
        }

        setIsAuthorized(true); // Toutes les vérifications sont passées
      } catch (error) {
        console.error('Erreur dans la vérification des accès :', error);
        await logOut();
        navigate('/login');
      } finally {
        setLoading(false);
      }
    };
    checkAccess();
  }, [user, initializing, navigate, eventID, logOut]);

  if (loading) {
    return (
      <Box height={'100%'} width={'100%'} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  return isAuthorized ? children : null;
};

export default ProtectedRoute;